module.exports = __webpack_public_path__ + "img/checkAppBackground.9e26291d.svg";